import React from 'react';
import { cn } from './cn';

const VARIANTS = {
  primary:
    'bg-ga-primary text-ga-text-on-primary hover:shadow-ga-glow hover:-translate-y-px active:translate-y-0',
  secondary:
    'border border-ga-border-subtle bg-ga-bg-surface text-ga-text-primary hover:bg-ga-bg-surface-subtle',
  danger: 'bg-ga-danger text-ga-text-on-primary hover:opacity-90',
  ghost:
    'border border-ga-border-subtle bg-transparent text-ga-text-primary hover:bg-ga-bg-surface-subtle',
};

const BASE =
  'inline-flex items-center justify-center gap-2 rounded-ga-md px-4 py-2.5 text-sm font-semibold transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0 disabled:hover:shadow-none';

export default function Button({
  variant = 'primary',
  className,
  as: Component = 'button',
  type = 'button',
  ...props
}) {
  return (
    <Component
      type={Component === 'button' ? type : undefined}
      className={cn(BASE, VARIANTS[variant] || VARIANTS.primary, className)}
      {...props}
    />
  );
}
